class InstallationDataSerializer {
  static deSerialize(data) {
    return {
      productId: data.IDArticulo,
      selectedOptions: (data.Instalaciones || []).map(item => ({
        amount: item.Cantidad,
        date: item.Fecha,
        endHour: item.HoraF,
        extraCost: item.Viatico,
        startHour: item.HoraI,
      })),
    };
  }
}

export { InstallationDataSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/InstallationDataSerializer.js